// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3v62Z","productName":"Table_productName__1lArF"};